import React, { useState } from "react";
import "assets/components/faq.scss";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import { Grid, Typography } from "@mui/material";

const faqList = [
  {
    question: "Chi è Denuncia Online?",
    answer: (
      <>
        <p style={{ margin: 0, padding: 0 }}>
          DenunciaOnline è la prima piattaforma in Italia che consente la{" "}
          <strong>
            presentazione di denunce in modalità interamente telematica
          </strong>
          .
        </p>
        <p style={{ margin: 0, padding: 0 }}>
          Si tratta di un servizio privato, non collegato alle forze
          dell'ordine.
        </p>
        <p>
          In ogni caso, le denunce presentate con il nostro portale hanno piena
          validità legale, al pari di quelle presentate presso i comandi e le
          questure, con il vantaggio di poter completare tutta la pratica da
          remoto.
        </p>
      </>
    ),
  },
  {
    question: "Come funziona nel dettaglio la denuncia online?",
    answer: (
      <>
        <p>La procedura è semplicissima, i passaggi sono i seguenti:</p>
        <p className="my-2">
          <strong>1. Accedi</strong>
          <br />
          Registrati con il tuo indirizzo email o accedi con il tuo account
          social.
        </p>
        <p className="my-2">
          <strong>2. Compila la denuncia</strong>
          <br />
          Scegli il modello di denuncia di cui hai bisogno e compila alcuni
          semplici campi guidati. Il documento di denuncia viene generato
          automaticamente dal nostro sistema.
        </p>
        <p className="my-2">
          <strong>3. Firma:</strong>
          <br />
          Per firmare la denuncia carica una foto del tuo documento di
          riconoscimento (passaporto o carta di identità. Non è ammessa la
          patente). Riceverai un codice OTP sul tuo smartphone e la tua firma
          digitale certificata sarà apposta.
        </p>
        <p className="my-2">
          <strong>4. Inviamo la pratica</strong>
          <br />
          Il nostro team verifica la tua denuncia e la inoltra telematicamente
          alla procura competente.
        </p>
        <p className="my-2">
          <strong>5. Ottieni la ricevuta</strong>
          <br />I sistemi della procura ci restituiranno la ricevuta di deposito
          della denuncia. Caricheremo la ricevuta nella tua dashboard e potrai
          utilizzarla per tutti gli scopi ammessi.
        </p>
      </>
    ),
  },
  {
    question: "Cosa include il servizio?",
    answer: (
      <>
        <p>
          Il servizio standard da €19,90 include il rilascio di una{" "}
          <span style={{ fontWeight: "bold" }}>firma digitale</span> certificata
          per sottoscrivere la denuncia e il{" "}
          <span style={{ fontWeight: "bold" }}>deposito della denuncia</span>{" "}
          presso la procura competente con rilascio della ricevuta. Qualunque
          altra attività accessoria non è inclusa nel costo standard e richiede
          costi aggiuntivi (es. ritiro o integrazione di una denuncia
          depositata, assistenza nel caso in cui dovesse aprirsi un processo a
          seguito delle indagini).
        </p>
      </>
    ),
  },
  {
    question: "Quali fatti posso denunciare?",
    answer: (
      <>
        <p>
          Puoi presentare una denuncia per le categorie di{" "}
          <span style={{ fontWeight: "bold" }}>reati più diffusi</span> (furti,
          truffe, danni, reati informatici, etc.). Cerca il modello standard
          pertinente nella tua dashboard. In caso di dubbi puoi scriverci in
          chat.{" "}
          <span style={{ fontWeight: "bold" }}>
            Non è possibile denunciare lo smarrimento
          </span>{" "}
          di oggetti in quanto tale fatto non costituisce reato.
        </p>
      </>
    ),
  },
  {
    question: "Cosa posso fare se non trovo il modello di denuncia adatto?",
    answer: (
      <>
        <p>
          <span style={{ fontWeight: "bold" }}>Contattaci in chat</span>, ti
          forniremo ogni informazione.
        </p>
      </>
    ),
  },
  {
    question: "Quali documenti e dati servono?",
    answer: (
      <>
        <p>
          Sono sufficienti i tuoi dati anagrafici, le informazioni sul fatto da
          denunciare e un tuo documento in corso di validità (carta di identità
          o passaporto.{" "}
          <span style={{ fontWeight: "bold" }}>Non è ammessa la patente</span>).
        </p>
      </>
    ),
  },
  {
    question: "Quali sono i tempi di deposito di una denuncia?",
    answer: (
      <>
        <p>
          Per creare e firmare la tua denuncia{" "}
          <span style={{ fontWeight: "bold" }}>bastano pochi minuti</span>.
          Invieremo la pratica prontamente e otterrai la ricevuta da parte della
          procura competente entro poche ore. Le denunce presentate il sabato,
          la domenica o i giorni festivi vengono depositate il primo giorno
          lavorativo utile successivo.
        </p>
      </>
    ),
  },
  {
    question: "Il servizio è interamente online?",
    answer: (
      <>
        <p>
          Sì, non devi recarti fisicamente in nessun comando o questura. Puoi
          completare l’
          <span style={{ fontWeight: "bold" }}>
            intera procedura da pc, tablet o smartphone
          </span>
          .
        </p>
      </>
    ),
  },
  {
    question: "Quali sono i vantaggi del servizio?",
    answer: (
      <>
        <p>
          Puoi presentare una{" "}
          <span style={{ fontWeight: "bold" }}>
            denuncia ovunque ti trovi in meno di 5 minuti
          </span>
          . Eviti perdite di tempo per spostamenti in città e lunghe code negli
          uffici. Non dovrai chiedere permessi o ferie a lavoro.
        </p>
      </>
    ),
  },
  {
    question: "Il servizio è sicuro?",
    answer: (
      <>
        <p>
          Certo! Il servizio ha{" "}
          <span style={{ fontWeight: "bold" }}>pieno valore legale</span>. La
          ricevuta di deposito che ottieni è equiparabile a quella rilasciata ai
          comandi o in questura.
        </p>
      </>
    ),
  },
  {
    question: "Se durante la procedura ho dei dubbi posso contattarvi?",
    answer: (
      <>
        <p>
          Ovviamente! Puoi{" "}
          <span style={{ fontWeight: "bold" }}>scriverci in chat</span> per ogni
          informazione.
        </p>
      </>
    ),
  },
  {
    question: "Quali sono i limiti del servizio?",
    answer: (
      <>
        <p>
          Non possiamo accettare denunce per fatti che si sono verificati{" "}
          <span style={{ fontWeight: "bold" }}>
            fuori dal territorio italiano
          </span>
          . Inoltre, il servizio non è utilizzabile da{" "}
          <span style={{ fontWeight: "bold" }}>minori di anni 18</span>.
        </p>
      </>
    ),
  },
  {
    question: "Come posso pagare?",
    answer: (
      <>
        <p>
          Puoi acquistare il servizio con{" "}
          <span style={{ fontWeight: "bold" }}>carta o PayPal</span>. Paghi solo
          per la singola pratica di denuncia acquistata. Non ci sarà nessun
          addebito automatico ricorrente.
        </p>
      </>
    ),
  },
];

const Faq = () => {
  const [openIndexes, setOpenIndexes] = useState([]);

  const toggleAnswer = (index) => {
    if (openIndexes.includes(index)) {
      setOpenIndexes(openIndexes.filter((i) => i !== index));
    } else {
      setOpenIndexes([...openIndexes, index]);
    }
  };

  return (
    <Grid
      id="Faq"
      container
      className="container container-section-6"
      sx={{
        display: "flex",
        justifyContent: { xs: "start !important", md: "center !important" },
      }}
    >
      <Grid item xs={12} md={9} style={{ marginBottom: "20px" }}>
        <h1 className="color1 title-sectionFaq-denuncia">Faq</h1>
        <Typography
          className="color2 subtitle-sectionFaq-denuncia"
          style={{ fontWeight: 600 }}
        >
          Domande frequenti sulla denuncia online
        </Typography>
      </Grid>

      {faqList.map((faq, index) => (
        <React.Fragment key={index}>
          {/* DOMANDA */}
          <Grid
            item
            xs={12}
            md={9}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Grid
              item
              xs={12}
              onClick={() => toggleAnswer(index)}
              sx={{
                marginTop: "15px",
                // backgroundColor: "#eaf2f7",
                backgroundColor: "#fff",
                border: "2px solid #eaf2f7",
                borderRadius: "4px",
                padding: { xs: "10px", md: "15px" },
                display: "flex",
                width: "fit-content",
                cursor: "pointer",
              }}
            >
              <Grid item xs={10}>
                <Typography
                  className="color1"
                  sx={{ fontSize: { xs: "14px", sm: "16px" }, fontWeight: 600 }}
                >
                  {faq.question}
                </Typography>
              </Grid>
              <Grid
                item
                xs={2}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <div
                  className={`icon-arrow-faq ${
                    openIndexes.includes(index) ? "rotate" : ""
                  }`}
                  style={{ marginLeft: "10px", alignSelf: "center" }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* RISPOSTA */}
          {openIndexes.includes(index) && (
            <Grid
              item
              xs={12}
              md={9}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <div
                style={{
                  backgroundColor: "#eaf2f7",
                  borderRadius: "4px",
                  padding: "15px",
                  marginTop: "15px",
                  width: "90%",
                }}
              >
                <Typography
                  className="color1"
                  sx={{ fontSize: { xs: "14px", sm: "16px" }, fontWeight: 400 }}
                >
                  {faq.answer}
                </Typography>
              </div>
            </Grid>
          )}
        </React.Fragment>
      ))}

      <Grid
        item
        xs={12}
        md={9}
        sx={{
          marginTop: "30px",
          display: { xs: "block", md: "flex" },
        }}
      >
        <Grid item xs={12} md={6} lg={5}>
          <a href="/register" className="btn btn-section-2">
            Inizia subito
          </a>
        </Grid>
        <Grid item xs={12} md={6} lg={5}>
          {" "}
          <p
            className="color1"
            style={{
              color: "#20305b",
              marginTop: "30px",
            }}
          >
            Hai ancora dubbi?{" "}
            <a
              href="https://chatting.page/wwiccu68pwawmgqq8qyafoe7daqap8ek"
              target="_blanck"
              className="color1"
              style={{
                fontWeight: "bold",
                color: "#20305b",
                marginLeft: "5px",
              }}
            >
              Scrivici in chat
            </a>{" "}
          </p>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Faq;
